import React from 'react';

const Presentation = () => {
  return (
    <div>
        <h1>L'avenir de l'esport et de l'influence</h1>
        <p>
        Fondé en 2021 par Joel Digbeu et Alex Cao, BMS est bien plus qu'un simple club esport.
        <br />
        <br />
        Nous allions performance et influence pour accompagner les jeunes talents vers l'excellence, en les aidant à se faire connaître tout en progressant dans leurs jeux.
        <br/>
        Spécialisés dans les jeux de combats, nous évoluons sur des titres emblématiques comme <i>Smash Ultimate</i>, <i>DragonBall Fighter Z</i>, <i>Street Fighter 6</i> et <i>Tekken 8</i>.
        <br/>
        <br />
        Notre ambition ? <b>Devenir la structure n°1</b> dans notre domaine et offrir à nos joueurs une plateforme pour briller sur la scène mondiale.
        <br/>
        </p>
     </div>
  )
}

export default Presentation